export function dateFromTimestamp(timestamp?: null | number) {
    if (!timestamp) return null

    const date = new Date(timestamp)

    const formatter = new Intl.DateTimeFormat('ru-RU', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    })

    return formatter.format(date)
}
